// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuTeaserGrid__container","grid":"MenuTeaserGrid__grid"};